import {Component, Input} from "@angular/core";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {first} from "rxjs/operators";
import {AuthService} from "../../../../../auth/auth.service";


@Component({
    selector: 'db-confirm-downgrade-agreement',
    templateUrl: './confirm-downgrade-agreement.component.html',
    styleUrls: ['./confirm-downgrade-agreement.component.scss'],
    standalone: false
})
export class ConfirmDowngradeAgreementComponent {

  @Input() downgradeTo: string;
  public loading: boolean;

  constructor(
    public readonly activeModal: DbActiveModal,
    private _authService: AuthService,
  ) {
  }

  public downgradeAgreement() {
    this.loading = true;
    this._authService.downgradeAgreement(this.downgradeTo)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe((response) => {
        this.loading = false;
        if (response.success) {
          this.activeModal.close();
        }
      });

  }



}
